import { useIsAndroidPhone } from './useIsAndroidPhone';
import { useIsIPhone } from './useIsIPhone';

export const useIsPhoneDevice = () => {
  const isIphone = useIsIPhone();
  const isAndroid = useIsAndroidPhone();
  return isIphone || isAndroid;
};
